import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse, LotPropertyBEGetCollectionByProjectIdStageIdPropertyIds } from '../../api/dtos';

const getData = (response?: SWRResponse<LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse, LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse>) => {
    return response?.data?.lotPropertyBulkEditRows;
}
const getError = (response?: SWRResponse<LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse, LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<StageGetSummaryCollectionByProjectIdResponse, StageGetSummaryCollectionByProjectIdResponse>) => ({});

const useLotPropertiesByProjectIdStageIdPropertyIds = (projectId?: number, stageId?: number, propertyIds?: number[], configuration?: SWRConfiguration<LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse, LotPropertyBEGetCollectionByProjectIdStageIdPropertyIdsResponse>) => {
    
    const request = useMemo(() => {
        stageId = !Number.isNaN(stageId) ? stageId : undefined;
        projectId = !Number.isNaN(stageId) ? projectId : undefined;
        
        return (stageId != undefined || projectId != undefined) && (propertyIds != undefined && propertyIds.length != 0) ? () => {
                return new LotPropertyBEGetCollectionByProjectIdStageIdPropertyIds({
                    projectId: projectId,
                    stageId: stageId,
                    propertyIds: propertyIds
                }) 
            }
            : undefined;
    }, [projectId, stageId, propertyIds])

    return useGet(request, { getData, getError}, configuration);
}

export default useLotPropertiesByProjectIdStageIdPropertyIds;